import { render } from "./CrmTabBar.vue?vue&type=template&id=191adeee&scoped=true"
import script from "./CrmTabBar.vue?vue&type=script&lang=js"
export * from "./CrmTabBar.vue?vue&type=script&lang=js"

import "./CrmTabBar.vue?vue&type=style&index=0&id=191adeee&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-191adeee"]])

export default __exports__